import { buildRouteHead } from "@/lib/seo/routeHead";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/es/caso-estudio-revision-linguistica-para-lider-farmaceutico")({
  head: () => buildRouteHead("/es/caso-estudio-revision-linguistica-para-lider-farmaceutico", { noIndex: true }),
  beforeLoad: () => {
    throw redirect({ to: "/es/casos-de-exito", replace: true });
  },
});
